'use client'

import React from 'react'
import { DataLoaderHooks } from './data-loader-hooks-type'

const DataLoaderContext = React.createContext<DataLoaderHooks | null>(null)

export const DataLoaderHooksProvider = ({
  dataLoaderHooks,
  children,
}: {
  dataLoaderHooks: DataLoaderHooks
  children: React.ReactNode
}) => {
  return <DataLoaderContext.Provider value={dataLoaderHooks}>{children}</DataLoaderContext.Provider>
}

export const useDataLoaderHooks = () => {
  const context = React.useContext(DataLoaderContext)

  if (!context) {
    throw new Error('useDataLoaderHooks must be used within a DataLoaderHooksProvider!')
  }

  return context
}
